<div class="content-block">
  <!-- Content Header (Page header) -->

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Cronologia <b>Log Accessi</b></h2>
        </div>
        <!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Log Accessi</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <section class="col-md-12">
    <div class="card">
      <div class="card-header primary">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
        </h3>
      </div>
      <!-- /.card-header -->
      <div class="filtro-grid">
        <div class="campo">
          <label>Da data</label>
          <dx-date-box
            type="date"
            [(value)]="daData"
            displayFormat="dd/MM/yyyy"
          >
          </dx-date-box>
        </div>

        <div class="campo">
          <label>A data</label>
          <dx-date-box type="date" [(value)]="aData" displayFormat="dd/MM/yyyy">
          </dx-date-box>
        </div>
        <div class="campo campo-bottone">
          <dx-button
            stylingMode="contained"
            text="Cerca"
            icon="search"
            type="normal"
            (onClick)="cercaLog()"
          >
          </dx-button>
        </div>
      </div>
      <div class="card-body">
        <dx-data-grid
          #gridArticoli
          [dataSource]="dataSource"
          [showBorders]="true"
          [focusedRowEnabled]="false"
          [focusedRowIndex]="0"
          [allowColumnResizing]="true"
          [columnAutoWidth]="true"
          [columnResizingMode]="columnResizingMode"
          [showColumnLines]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="false"
          [allowColumnReordering]="true"
          [wordWrapEnabled]="false"
          (onExporting)="onExporting($event)"
        >
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-paging [pageSize]="20"></dxo-paging>
          <dxo-pager
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [allowedPageSizes]="[10, 20, 50, 100]"
          ></dxo-pager>
          <dxo-filter-row [visible]="false"></dxo-filter-row>
          <dxo-header-filter
            [visible]="true"
            [allowSearch]="true"
          ></dxo-header-filter>
          <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

          <dxo-editing
            mode="row"
            [allowAdding]="false"
            [allowUpdating]="false"
            [allowDeleting]="false"
            [useIcons]="true"
          >
            <dxo-texts
              confirmDeleteMessage="Confermare la cancellazione?"
            ></dxo-texts>
          </dxo-editing>

          <dxi-column dataField="username" caption="Username" width="130">
          </dxi-column>

          <dxi-column
            dataField="dataOra"
            caption="Data"
            dataType="date"
            format="dd/MM/yyyy HH:MM:ss"
            [sortIndex]="1"
            sortOrder="asc"
          >
          </dxi-column>

          <dxi-column dataField="indirizzoIP" caption="Indirizzo IP">
          </dxi-column>
          <!--
            <dxi-column
                dataField="ruolo"
                caption="Ruolo"
                >
            </dxi-column>
            -->

          <dxi-column dataField="tipo" caption="Tipo"> </dxi-column>
        </dx-data-grid>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </section>
</div>
